<template>
  <div>
    <h1>Your Suggestion</h1>
    <form v-on:submit.prevent="formSubmit">
      <div class="form-group">
        <textarea v-model="suggestion" class="form-control" rows="4" required placeholder="Type your suggestion here"></textarea>
      </div>
      <b-button type="submit" variant="outline-primary">Submit Suggestion</b-button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Suggestion',

  data () {
    return {
      suggestion: ''
    }
  },
  methods: {
    formSubmit () {
      this.$http.post(process.env.VUE_APP_URL + '/suggestions', {
        suggestion: this.suggestion
      })
        .then(response => {
          let msg = 'Suggestion #' + response.data.sug_id + ' added.'

          this.$bvToast.toast(msg, {
            autoHideDelay: 5000,
            variant: 'success',
            solid: true
          })

          this.suggestion = ''
        })
        .catch(function (error) {
          this.$bvToast.toast(error, {
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          })
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
